/* @flow */
import Entity from 'lib/Entity';

export default class LinkPreview extends Entity {
  getTitle(): string {
    return this.get('title');
  }

  getDescription(): string {
    return this.get('description');
  }

  getImageUrl(): string {
    return this.get('image');
  }

  getUrl(): string {
    return this.get('url');
  }

  toGraphQL(): * {
    return {
      title: this.getTitle(),
      description: this.getDescription(),
      url: this.getUrl(),
      imageUrl: this.getImageUrl(),
    };
  }
}
